
function gridPos(playerPos) {
    switch(playerPos) {
        case 72: return {row:0, column:0}
        case 71: return {row:0, column:1}
        case 70: return {row:0, column:2}
        case 69: return {row:0, column:3}
        case 68: return {row:0, column:4}
        case 67: return {row:0, column:5}
        case 66: return {row:0, column:6}
        case 65: return {row:0, column:7}
        case 64: return {row:0, column:8}
        case 63: return {row:1, column:8}
        case 62: return {row:1, column:7}
        case 61: return {row:1, column:6}
        case 60: return {row:1, column:5}
        case 59: return {row:1, column:4}
        case 58: return {row:1, column:3}
        case 57: return {row:1, column:2}
        case 56: return {row:1, column:1}
        case 55: return {row:1, column:0}
        case 54: return {row:2, column:0}
        case 53: return {row:2, column:1}
        case 52: return {row:2, column:2}
        case 51: return {row:2, column:3}
        case 50: return {row:2, column:4}
        case 49: return {row:2, column:5}
        case 48: return {row:2, column:6}
        case 47: return {row:2, column:7}
        case 46: return {row:2, column:8}
        case 45: return {row:3, column:8}
        case 44: return {row:3, column:7}
        case 43: return {row:3, column:6}
        case 42: return {row:3, column:5}
        case 41: return {row:3, column:4}
        case 40: return {row:3, column:3}
        case 39: return {row:3, column:2}
        case 38: return {row:3, column:1}
        case 37: return {row:3, column:0}
        case 36: return {row:4, column:0}
        case 35: return {row:4, column:1}
        case 34: return {row:4, column:2}
        case 33: return {row:4, column:3}
        case 32: return {row:4, column:4}
        case 31: return {row:4, column:5}
        case 30: return {row:4, column:6}
        case 29: return {row:4, column:7}
        case 28: return {row:4, column:8}
        case 27: return {row:5, column:8}
        case 26: return {row:5, column:7}
        case 25: return {row:5, column:6}
        case 24: return {row:5, column:5}
        case 23: return {row:5, column:4}
        case 22: return {row:5, column:3}
        case 21: return {row:5, column:2}
        case 20: return {row:5, column:1}
        case 19: return {row:5, column:0}
        case 18: return {row:6, column:0}
        case 17: return {row:6, column:1}
        case 16: return {row:6, column:2}
        case 15: return {row:6, column:3}
        case 14: return {row:6, column:4}
        case 13: return {row:6, column:5}
        case 12: return {row:6, column:6}
        case 11: return {row:6, column:7}
        case 10: return {row:6, column:8}
        case 9: return {row:7, column:8}
        case 8: return {row:7, column:7}
        case 7: return {row:7, column:6}
        case 6: return {row:7, column:5}
        case 5: return {row:7, column:4}
        case 4: return {row:7, column:3}
        case 3: return {row:7, column:2}
        case 2: return {row:7, column:1}
        case 1: return {row:7, column:0}
        case 0: return {row:0, column:4}
        default: return {row:0, column:4}
    }
}

export function single_game_coordinates(playerPos, cellWidth, cellHeight, tablePaddingTop, tablePaddingleft) {
    const cellPaddingTop = 5
    const chipRadius = 25

    const top = tablePaddingTop + gridPos(playerPos).row * (cellHeight + 1) + cellPaddingTop
    const left = tablePaddingleft + gridPos(playerPos).column * (cellWidth + 1) + 5 + cellWidth/2 - chipRadius

    return {top: top, left: left}
}

export function cell_coords(cell_number, cellWidth, cellHeight, tablePaddingTop, tablePaddingleft) {
    const startY = gridPos(cell_number).row * (cellHeight + 1) + tablePaddingTop
    const startX = gridPos(cell_number).column * (cellWidth + 1) + tablePaddingleft + 5
    const endY = startY + (cellHeight + 1)
    const endX = startX + (cellWidth + 1)
    return {
        start: {
            x: startX,
            y: startY
        },
        end: {
            x: endX,
            y: endY
        }
    }
}


export function calculateArrows(steps, cellWidth, cellHeight, tablePaddingTop, tablePaddingleft) {
    const arr = Array.from(Array(73).keys())
    const dots = {}
    for (const el of arr) {
        dots[el] = {
            total_dots: 0,
            dots_taken:0
        }
    }

    dots[68].total_dots = 1
    dots[68].dots_taken = 1

    for (const step of steps) {
        dots[step.to_position].total_dots += 1
    }

    const arrows_coords = []

    const cell_68_coords = cell_coords(68, cellWidth, cellHeight, tablePaddingTop, tablePaddingleft)

    let previous_arrow_end = {
        x:cell_68_coords.start.x +
            ((cell_68_coords.end.x - cell_68_coords.start.x)/(dots[68].total_dots + 1)),
        y:cell_68_coords.start.y +
            ((cell_68_coords.end.y - cell_68_coords.start.y)/(dots[68].total_dots + 1))

    }

    for (const step of steps) {
        const end_total_dots = dots[step.to_position].total_dots
        const end_dots_taken = dots[step.to_position].dots_taken

        const end_cell_coords = cell_coords(step.to_position, cellWidth, cellHeight, tablePaddingTop, tablePaddingleft)

        const arrow_end_x =
            end_cell_coords.start.x +
            ((end_cell_coords.end.x - end_cell_coords.start.x)/(end_total_dots + 1)) * (end_dots_taken + 1)

        const arrow_end_y = end_cell_coords.start.y +
            ((end_cell_coords.end.y - end_cell_coords.start.y)/(end_total_dots + 1)) * (end_dots_taken + 1)

        const arrow = {
            start: {
                x: previous_arrow_end.x,
                y: previous_arrow_end.y
            },
            end: {
                x: arrow_end_x,
                y: arrow_end_y
            }
        }
        arrows_coords.push(arrow)

        dots[step.to_position].dots_taken += 1
        previous_arrow_end = {
            x: arrow_end_x,
            y: arrow_end_y
        }
    }
    return arrows_coords

}

export function group_game_coordinates(playerPos, cellWidth, cellHeight, tablePaddingTop, tablePaddingleft) {
    const cellPaddingTop = 5
    const chipRadius = 20

    const top = tablePaddingTop + gridPos(playerPos).row * (cellHeight + 1) + cellPaddingTop
    const left = tablePaddingleft + gridPos(playerPos).column * (cellWidth + 1) + 7 + cellWidth/2 - chipRadius

    return {top: top, left: left}
}

export function calculatePlayerPosShift(playerIdsList, playerPositions, currentPlayerId) {
    // playerIdsList: [player_id1, player_id2, ...]
    // playerPositions: {player_id1: 0, player_id2: 0, player_id2: 68}
    // currentPlayerId: player_id1
    if (!playerPositions) {
        return {
            top: 0,
            left: 0
        }
    }

    const currentPlayerPosition = playerPositions[currentPlayerId]
    const playerIndex = {}

    for (const [index, element] of playerIdsList.entries()) {
        playerIndex[element] = index
    }

    let playersOnCurrentPlayerPosition = [];

    for (const playerId of playerIdsList) {
        // find all players standing on the same field as currentPlayer
        // including current player
        // 0 and 68 positions considered equal
        if ((playerPositions[playerId] === currentPlayerPosition) ||
            (playerPositions[playerId] === 0 && currentPlayerPosition === 68) ||
            (playerPositions[playerId] === 68 && currentPlayerPosition === 0)) {
            playersOnCurrentPlayerPosition.push(playerId)
        }
    }

    if (playersOnCurrentPlayerPosition.length === 1) {
        // player is alone on his position, stays at the center
        return {
            top: 0,
            left: 0
        }
    }

    if (playersOnCurrentPlayerPosition.length === 2) {
        //     there's one neighbour, split left and right
        if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 0) {
            //     player is first, shift left
            return {
                top: 0,
                left: -20
            }
        } else {
            //     player is second, shift right
            return {
                top: 0,
                left: 20
            }
        }
    }

    if (playersOnCurrentPlayerPosition.length === 3) {
        //     there's two neighbours, split left center right
        if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 0) {
            //     player is first, shift left
            return {
                top: 0,
                left: -25
            }
        } else if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 1) {
            //     player is second, stay in center
            return {
                top: 25,
                left: 0
            }
        } else {
            //     player is third, shift right
            return {
                top: 0,
                left: 25
            }
        }
    }

    if (playersOnCurrentPlayerPosition.length === 4) {
        //     there's 4 players on the same position, shift corners and center
        if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 0) {
            //     player is first, shift left top
            return {
                top: -5,
                left: -20
            }
        } else if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 1) {
            //     player is second, right top
            return {
                top: -5,
                left: 20
            }
        } else if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 2) {
            //     player is third, shift left bottom
            return {
                top: 35,
                left: -20
            }
        } else if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 3) {
            //     player is forth, shift right bottom
            return {
                top: 35,
                left: 20
            }
        } else {
            //     player is fifth, stay in center
            return {
                top: 15,
                left: 0
            }
        }
    }

    if (playersOnCurrentPlayerPosition.length === 5) {
        //     there's 4 players on the same position, shift corners and center
        if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 0) {
            //     player is first, shift left top
            return {
                top: -5,
                left: -25
            }
        } else if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 1) {
            //     player is second, right top
            return {
                top: -5,
                left: 25
            }
        } else if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 2) {
            //     player is third, shift left bottom
            return {
                top: 35,
                left: -25
            }
        } else if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 3) {
            //     player is forth, shift right bottom
            return {
                top: 35,
                left: 25
            }
        } else {
            //     player is fifth, stay in center
            return {
                top: 15,
                left: 0
            }
        }
    }

    if (playersOnCurrentPlayerPosition.length === 6) {
        //     there's 4 players on the same position, shift corners and center
        if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 0) {
            //     player is first, shift left top
            return {
                top: -5,
                left: -25
            }
        } else if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 1) {
            //     player is second, center top
            return {
                top: -5,
                left: 0
            }
        } else if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 2) {
            //     player is third, shift right top
            return {
                top: -5,
                left: 25
            }
        } else if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 3) {
            //     player is forth, left bottom
            return {
                top: 35,
                left: -25
            }
        } else if (playersOnCurrentPlayerPosition.indexOf(currentPlayerId) === 4) {
            //     player is fifth, center bottom
            return {
                top: 35,
                left: 0
            }
        } else {
            //     player is sixth, right bottom
            return {
                top: 35,
                left: 25
            }
        }
    }
}